<template>
  <BgImageLayout :title="toolbarTitle">
    <template #actions-after>
      <q-btn to="/reports" size="sm" color="tertiary">
        Go to reports
      </q-btn>
    </template>

    <Grid gtr="auto 1fr" class="financial-page full-height">
      <OpaqueCardHeaderWithTabs :tabs="tabs" />

      <keep-alive>
        <router-view />
      </keep-alive>
    </Grid>
  </BgImageLayout>
</template>

<script>
import OpaqueCardHeaderWithTabs from '@/ui/OpaqueCardHeaderWithTabs'

export default {
  components: {
    OpaqueCardHeaderWithTabs
  },

  computed: {
    toolbarTitle() {
      return `Financials`
    }
  },

  created() {
    this.tabs = [
      {
        id: 1,
        name: 'Insights',
        route: '/financial/insights',
        page: this.__guide.financialInsights
      },
      {
        id: 2,
        name: 'Predictions',
        route: '/financial/predictions',
        page: this.__guide.predictions
      }
    ]
  }
}
</script>
